<script>
    import Dashboard from '../../Models/dashboardModel';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';

    import { isAdmin } from '../../Utilities/Session.svelte';

    let dashboards = Dashboard.getDashboardList();

    function addDashboard() {
        addFormModal({
            fields: forms.dashboard,
            title: "Add Dashboard",
        }).then((data) => {
            Dashboard.createDashboard(data);
        }).catch(e => {});
    }

    function deleteDashboard(dashboard) {
        confirm(`Are you sure you want to delete ${dashboard.name}?`).then(() => {
            Dashboard.deleteDashboard(dashboard._id).then(() => {
                notifier.success("Dashboard Deleted");
            });
        })
    }
</script>

<Loader loading={!$dashboards}>
    <div class="container is-fluid">
        <h1 class="title is-1">Dashboards</h1>
        <SortableTable sortFields={tables["dashboards"]} tableData={$dashboards} actionsWidth="{$isAdmin ? 250 : 180 }">
            <div slot="filterActions">
                {#if $isAdmin}
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addDashboard}>Add Dashboard</button>
                </div>
                {/if}
            </div>
            <div slot="footerActions">
                {#if $isAdmin}
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addDashboard}>Add Dashboard</button>
                </div>
                {/if}
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={dashboard}>
                {#if $isAdmin }
                    <a class="button is-info" href="#/dashboard/edit/{dashboard._id}">Manage</a>
                {/if}
                <button class="button is-danger" on:click={() => deleteDashboard(dashboard)}>Delete</button>
                <a class="button is-link" href="#/dashboard/{dashboard._id}">Open</a>

                <a class="button is-primary" href="#/dashboard/mappings/{dashboard._id}">Question Mapping</a>
            </div>
        </SortableTable>
    </div>
</Loader>

<style>
    .container {
        padding-left: 32px;
        padding-right: 32px;
    }
</style>